import { ContextualField } from '@models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const Documentation: ContextualField = {
    modelName: 'documentation',
    propertyType: PropertyType.Documentation,
    label: 'Documentation',
    propertyName: 'documentationProperty',
    icon: 'fa-file-text'
};